export default __webpack_public_path__ + "images/close_f185d5.svg";